import { gql } from '@apollo/client'

export const Query = gql`
  query Documents($companyId: ID!, $filters: DocumentFilters, $order: DocumentOrder, $after: String, $before: String, $first: Int, $last: Int) {
    documents(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        reference
        number
        dateIssued
        dateDue
        subject {
          ... on AssetType { id name }
          ... on Asset { id name }
          ... on Package { id name }
          ... on Event { id name: description }
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
